module.exports = __webpack_public_path__ + "static/img/top02.f959026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/top02.png
// module id = vtD5
// module chunks = 1